import * as Yup from "yup";

import { BOOLEAN_OPTIONS, booleanOptionLabels } from "@/constant/GeneralOptions/boolean";
import { DEFAULT_LANGUAGE } from "@/constant/Languages/language";
import { STATUS } from "@/constant/statusConstants";

const booleanOptionLabelsMap = booleanOptionLabels();
const boLabelYes = booleanOptionLabelsMap[BOOLEAN_OPTIONS.YES];
const boLabelNo = booleanOptionLabelsMap[BOOLEAN_OPTIONS.NO];

const getPostSchema = (isEdit = false, targetLang = DEFAULT_LANGUAGE) =>
  Yup.object().shape({
    title: Yup.string()
      .label("Title")
      .required()
      .max(120),
    sub_title: Yup.string()
      .label("Subtitle")
      .required()
      .max(120),
    content: Yup.string()
      .label("Content")
      .required(),
    status: Yup
      .string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    sport_id: Yup
      .string()
      .label("Sport ID")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    blog_category_id: Yup
      .string()
      .label("Category")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    banner_url: Yup.mixed().label("Banner").when([], {
      is: () => !isEdit && targetLang === DEFAULT_LANGUAGE,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable(),
    }),
    thumbnail_url: Yup.mixed().label("Thumbnail").when([], {
      is: () => !isEdit && targetLang === DEFAULT_LANGUAGE,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable(),
    }),
    auto_translate: Yup
      .bool()
      .label("Translate All")
      .nullable()
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Translate All must be one of the following values: ${boLabelYes}, ${boLabelNo}`
      ),
  });

export default getPostSchema;
